import { ApolloLink } from "@apollo/client";
import DOMPurify from "dompurify";
import _ from "lodash";

// Recursively sanitize all string values in variables
const sanitizeVariables = vars => {
  DOMPurify.addHook("uponSanitizeElement", (node, data) => {
    data.allowedTags[data.tagName] = true;
  });

  DOMPurify.setConfig({
    ADD_ATTR: ["target", "messageIds", "source"],
  });

  if (_.isString(vars)) {
    if (/<\/?[a-z][\s\S]*>/i.test(vars)) {
      return DOMPurify.sanitize(vars);
    }
  }

  if (_.isArray(vars)) {
    return vars.map(sanitizeVariables);
  }

  if (_.isPlainObject(vars)) {
    return _.mapValues(vars, sanitizeVariables);
  }

  return vars;
};

const sanitizeLink = new ApolloLink((operation, forward) => {
  const isMutation = operation.query.definitions.some(
    def => def.kind === "OperationDefinition" && def.operation === "mutation"
  );

  const operationName = _.get(operation, "operationName");

  const skipSanitization =
    _.includes(["createAiMessage", "updateAiMessage"], operationName) ||
    _.has(operation.variables, "input.modalityFile"); // for AI tutor code editor functionality

  if (isMutation && !skipSanitization && operation.variables) {
    operation.variables = sanitizeVariables(operation.variables);
  }

  return forward(operation);
});

export default sanitizeLink;
